import React from 'react'
import Layout from './layout/layout'

function Homepage() {
  return (
    <Layout>
      <h1>This is the home page</h1>
    </Layout>
  )
}

export default Homepage
